module.exports = __webpack_public_path__ + "media/images/childcare/nassima-38be53ef600f0ac115f4ba98c382b36a.jpg";